import type { EvaluationQuestionType } from "../views/evaluations/evaluationFormsApi";

export const EVALUATION_QUESTION_TYPE_LABEL: Record<EvaluationQuestionType, string> = {
  TEXT: "Texto",
  SINGLE_CHOICE: "Escolha Única",
  SCALE: "Escala",
  BOOLEAN: "Sim/Não",
  MULTI_CHOICE: "Múltiplas opções",
  minValue: "Valor Mínimo",
  maxValue: "Valor Máximo",
};

export const getEvaluationQuestionTypeLabel = (type: EvaluationQuestionType) =>
  EVALUATION_QUESTION_TYPE_LABEL[type] ?? String(type);
